import { render, staticRenderFns } from "./Infrastructure.vue?vue&type=template&id=3c23bf00&scoped=true&"
import script from "./Infrastructure.vue?vue&type=script&lang=js&"
export * from "./Infrastructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23bf00",
  null
  
)

export default component.exports